export const markHydrationComplete = (node: HTMLButtonElement) => {
  if (node) {
    node.dataset.testRenderState = "complete";
  }
};
